import {
	curatorRegionConstants
}from "./constants"
import actions from '../../actions'
const initialState = {
	//getList
	isSending : false,
	list      : null,
	listPaged : null,
	changed   : null,
	error     : null,
	count     : null
}

export default function (state = initialState, action){
	switch (action.type){
		case curatorRegionConstants.Create.REQUEST:
		case curatorRegionConstants.Update.REQUEST:
		case curatorRegionConstants.Delete.REQUEST:
		case curatorRegionConstants.GetPaged.REQUEST:
			return {
				...state,
				isSending       : true,
				changed         : null,
				createIsFailure : null
			}
		case curatorRegionConstants.Update.FAILURE:
		case curatorRegionConstants.Create.FAILURE:
		case curatorRegionConstants.Delete.FAILURE:
		case curatorRegionConstants.GetPaged.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case curatorRegionConstants.Create.SUCCESS:
			return {
				...state,
				isSending       : false,
				changed         : action.payload.result ? actions.create : null,
				createIsFailure : action.payload.result === false ? 'Проверьте введёные данные!' : null
			}

		case curatorRegionConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}

		case curatorRegionConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case curatorRegionConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				listPaged : action.payload.result.items,
				count     : action.payload.result.count
			}

		case curatorRegionConstants.CLEAR:
			return {
				...state,
				changed   : null,
				isSending : false,
				paged     : null,
				list      : null,
				count    	: null,
				listPaged : null
			}
		default:
			return state
	}
}
